import RestaurantHeader from "./RestaurantHeader";

export default RestaurantHeader;
